module.exports = __webpack_public_path__ + "img/1521676498.92aaf7c7.jpg";